// Componente de Loading de Tela Cheia (FullScreenLoading)
export function LoadingScreen() {
  return (
    <div className="loading-screen-full">
      <div className="loading-spinner"></div>
    </div>
  );
}

// Componente de Loading para Botões (ButtonLoading)
export function ButtonLoading() {
  return <div className="loading-spinner-button"></div>;
}

export function ButtonLoadingBlue() {
  return <div className="loading-spinner-button-blue"></div>;
}
